module.exports = __webpack_public_path__ + "img/bb_g3_t_mouth-01.c4799b9a.svg";